import React from 'react'
import ReactDOM from 'react-dom'
import axios from 'axios'
import TagManager from 'react-gtm-module'

import keycloak from './config/keycloak'

import Routing from './routes/Routes'
import { BrowserRouter } from 'react-router-dom'

import { ReactKeycloakProvider } from '@react-keycloak/web'
import { QueryClient, QueryClientProvider } from 'react-query'

import { ThemeProvider } from '@mui/material/styles'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'

import theme from './theme/theme'
import CssBaseline from '@mui/material/CssBaseline'
import './styles/index.css'

import { ModalProvider, ModalConsumer } from './stores/ModalContext'
import { NavigationProvider } from './stores/NavigationContext'
import { IntercomProvider } from 'react-use-intercom'
import { GeneralContextProvider } from './stores/GeneralContext'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
})

axios.defaults.baseURL = `${
  window?._env_?.REACT_APP_PORTAL_BACKEND_URL !== undefined
    ? window?._env_?.REACT_APP_PORTAL_BACKEND_URL
    : process.env.REACT_APP_PORTAL_BACKEND_URL
}`

const setAxiosToken = (tokens) => {
  axios.defaults.headers.common = { Authorization: `Bearer ${tokens.token}` }
}

const tagManagerArgs = {
  gtmId: 'GTM-TFL85VD',
}

const ModalRoot = () => (
  <ModalConsumer>
    {({ component: Component, props, hideModal }) =>
      Component ? <Component {...props} onClose={hideModal} /> : null
    }
  </ModalConsumer>
)

const INTERCOM_API = `${
  window?._env_?.REACT_APP_INTERCOM_ID !== undefined
    ? window?._env_?.REACT_APP_INTERCOM_ID
    : process.env.REACT_APP_INTERCOM_ID
}`

ReactDOM.render(
  <React.StrictMode>
    <ReactKeycloakProvider authClient={keycloak} onTokens={setAxiosToken}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <CssBaseline />
            <GeneralContextProvider>
              <NavigationProvider>
                <ModalProvider>
                  <ModalRoot />
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <IntercomProvider appId={INTERCOM_API}>
                      <Routing />
                    </IntercomProvider>
                  </LocalizationProvider>
                </ModalProvider>
              </NavigationProvider>
            </GeneralContextProvider>
          </BrowserRouter>
        </ThemeProvider>
      </QueryClientProvider>
    </ReactKeycloakProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

TagManager.initialize(tagManagerArgs)
